module.exports = __webpack_public_path__ + "static/media/settings.eefb3203.svg";